import { OptionCard, StepHeading } from "@/components/booking/OptionCard";
import { gbp } from "@/lib/booking";

export function StepExtras({ catalog, service, form, set }) {
  const included = service.included_extras || [];
  const available = catalog.extras.filter((e) => !included.includes(e.key));
  const toggle = (extra) => {
    const has = form.extras.includes(extra.key);
    const next = has
      ? form.extras.filter((k) => k !== extra.key)
      : [...form.extras.filter((k) => !extra.excludes.includes(k)), extra.key];
    set({ extras: next });
  };

  return (
    <div>
      <StepHeading title="Any extras?" hint="Optional - each extra is added to your fixed price automatically." />
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {available.map((e) => (
          <OptionCard
            key={e.key}
            testId={`booking-extra-${e.key}`}
            selected={form.extras.includes(e.key)}
            onClick={() => toggle(e)}
            title={e.name}
            subtitle={e.description}
            price={`+${gbp(e.price)}`}
            className="py-4"
          />
        ))}
      </div>
      <p className="mt-4 text-xs text-faint" data-testid="booking-extras-hint">
        {included.length
          ? `Inside oven and inside fridge are already included in ${service.name} - no extra charge.`
          : 'Selecting "Inside oven + fridge" replaces the individual oven and fridge options.'}
      </p>
    </div>
  );
}
